//资源管理
import request from '@/utils/request'

//新增资源信息
export function addResource(param) {
    return request.post('/resource/addResource', param)
}

//查询资源列表
export function queryResourceByConditions(param) {
    return request.post('/resource/queryResourceByConditions', param)
}